if (!window.beaePageJS) {
                                    window.beaePageJS = [];
                                }
                                let jsHandle_637915b59791831ebc13b162 = () => {
                    if (document.querySelector('.beae-gb37oewu:not([data-beae-bind])')) {
                        (function() {!this.$el||!this.$el.querySelector(".beae-section-background-video")||typeof handleVideoBg=="undefined"||!this.isLive||(handleVideoBg.bind(this)(),window.addEventListener("resize",handleVideoBg.bind(this)))}).call({
                            $el: document.querySelector('.beae-gb37oewu:not([data-beae-bind])'),
                            
                            id: 'beae-gb37oewu',
                            isLive: true
                        });
                        document.querySelector('.beae-gb37oewu:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                
                    if (document.querySelector('.beae-xdki8xkj:not([data-beae-bind])')) {
                        (function() {!this.$el||!this.$el.querySelector(".beae-section-background-video")||typeof handleVideoBg=="undefined"||!this.isLive||(handleVideoBg.bind(this)(),window.addEventListener("resize",handleVideoBg.bind(this)))}).call({
                            $el: document.querySelector('.beae-xdki8xkj:not([data-beae-bind])'),
                            
                            id: 'beae-xdki8xkj',
                            isLive: true
                        });
                        document.querySelector('.beae-xdki8xkj:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                }
                                if (window.beaejQuery) {
                                    jsHandle_637915b59791831ebc13b162()
                                } else {
                                    window.beaePageJS.push(jsHandle_637915b59791831ebc13b162)
                                }